import React from 'react'

import { Row } from 'antd'

export default function DataDeletionPolicy() {
  return (
    <div style={{ overflow: 'hidden' }}>
      <Row justify="center" style={{ marginTop: 50, marginBottom: 80 }}>
        <Row justify="center" style={{ maxWidth: 800 }}>
          <h1>Facebook Data Deletion Instructions</h1>

          <div style={{ width: 1000 }}>
            <div style={{ marginTop: 70 }}>
              According to the Facebook Platform rules, we have to provide User Data Deletion
              Callback URL or Data Deletion Instructions URL. If you want to delete your activities
              for el-gaucho, you can remove your activities by the following instructions.
            </div>
            <div style={{ marginTop: 20 }}>
              <div>Go to Your Facebook Account’s Setting & Privacy. Click ” Setting “.</div>
              <div>
                Then, go to ” Apps and Websites” and you will see all of your Apps activities.
              </div>
              <div>Select the option box of el-gaucho.</div>
              <div>Click ” Remove” button.</div>
              <div>Go to Your Facebook Account’s Setting & Privacy. Click ” Setting “.</div>
            </div>
          </div>
        </Row>
      </Row>
    </div>
  )
}
